/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRightFromBracket: {
  name: 'arrow-right-from-bracket';
  data: string;
} = {
  name: 'arrow-right-from-bracket',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 .5A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h1a.5.5 0 0 0 0-1H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 0-1H2Zm10.4 3.2a.5.5 0 0 0-.8.6L14 7.5H5a.5.5 0 0 0 0 1h9l-2.4 3.2a.5.5 0 0 0 .8.6l3-4a.5.5 0 0 0 0-.6l-3-4Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
